var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3263_1177",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.597656,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3263_1177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 17.3477C12.2129 17.3477 12.391 17.2757 12.5345 17.1319C12.6782 16.9882 12.75 16.8102 12.75 16.5977V12.3477C12.75 12.1352 12.6781 11.957 12.5343 11.8132C12.3904 11.6695 12.2122 11.5977 11.9998 11.5977C11.7871 11.5977 11.609 11.6695 11.4655 11.8132C11.3218 11.957 11.25 12.1352 11.25 12.3477V16.5977C11.25 16.8102 11.3219 16.9882 11.4658 17.1319C11.6096 17.2757 11.7878 17.3477 12.0003 17.3477ZM12 9.88616C12.2288 9.88616 12.4207 9.80874 12.5755 9.65391C12.7303 9.49907 12.8077 9.30724 12.8077 9.07841C12.8077 8.84957 12.7303 8.65774 12.5755 8.50291C12.4207 8.34824 12.2288 8.27091 12 8.27091C11.7712 8.27091 11.5793 8.34824 11.4245 8.50291C11.2697 8.65774 11.1923 8.84957 11.1923 9.07841C11.1923 9.30724 11.2697 9.49907 11.4245 9.65391C11.5793 9.80874 11.7712 9.88616 12 9.88616ZM12.0017 22.0977C10.6877 22.0977 9.45267 21.8483 8.2965 21.3497C7.14033 20.851 6.13467 20.1742 5.2795 19.3194C4.42433 18.4646 3.74725 17.4593 3.24825 16.3037C2.74942 15.148 2.5 13.9132 2.5 12.5994C2.5 11.2854 2.74933 10.0503 3.248 8.89416C3.74667 7.73799 4.42342 6.73232 5.27825 5.87716C6.13308 5.02199 7.13833 4.34491 8.294 3.84591C9.44967 3.34707 10.6844 3.09766 11.9983 3.09766C13.3123 3.09766 14.5473 3.34699 15.7035 3.84566C16.8597 4.34432 17.8653 5.02107 18.7205 5.87591C19.5757 6.73074 20.2528 7.73599 20.7518 8.89166C21.2506 10.0473 21.5 11.2821 21.5 12.5959C21.5 13.9099 21.2507 15.145 20.752 16.3012C20.2533 17.4573 19.5766 18.463 18.7218 19.3182C17.8669 20.1733 16.8617 20.8504 15.706 21.3494C14.5503 21.8482 13.3156 22.0977 12.0017 22.0977ZM12 20.5977C14.2333 20.5977 16.125 19.8227 17.675 18.2727C19.225 16.7227 20 14.831 20 12.5977C20 10.3643 19.225 8.47266 17.675 6.92266C16.125 5.37266 14.2333 4.59766 12 4.59766C9.76667 4.59766 7.875 5.37266 6.325 6.92266C4.775 8.47266 4 10.3643 4 12.5977C4 14.831 4.775 16.7227 6.325 18.2727C7.875 19.8227 9.76667 20.5977 12 20.5977Z",
    fill: "#767680"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.123f2457d67cdafcc4b25c762336007f.svg";
export { ForwardRef as ReactComponent };